<footer id="Contacto" [class]="layout" style="text-align: center">
    <div class="container">
        <div class="footer-widget mt-5 mb-5">
            <div class="row">
                <div class="col-lg-12 order-lg-4 order-5">
                    <div class="row">
                        <div class="col-lg-3 col-sm-6">
                            <img src="assets/img/SelloFooter.png" alt="sello">
                        </div>
                        <div class="col-lg-3 col-sm-6 mt-5 pt-5" id="info_ubicacion">
                            <img src="assets/img/UbicacionP.png" alt="direccion">
                            <div class="texto_descriptivo">
                                <h2>Dirección</h2>
                                <p>Blvd. Orozco y Jiménez 2306, Col Los Jacales, Lagos de Moreno, Jalisco. C.p. 47470</p>
                            </div>
                        </div>
                        <div class="col-lg-3 col-sm-6 mt-5 pt-5" id="info_telefono">
                            <img src="assets/img/TelefonoP.png" alt="telefono">
                            <div class="texto_descriptivo">
                                <h2>Teléfono</h2>
                                <p>55 1684 9458</p>
                            </div>
                        </div>
                        <div class="col-lg-3 col-sm-6 mt-5 pt-5" id="info_email">
                            <a routerLink="/careers">
                                <img src="assets/img/EmailP.png" alt="email">
                                <div class="texto_descriptivo">
                                    <h2>Email</h2>
                                    <p>info@cacm.com.mx</p>
                                </div>
                            </a>
                        </div>
                        <div class="col-lg-12 order-lg-4 order-5" style="display: flex;">
                            <div class="mt-2" style="padding-left: 400px;" id="info_aviso_legal">
                                <a routerLink="/aviso-legal">
                                    <img src="assets/img/avisoLegal.png" alt="aviso-legal" style="height: 70px; ">
                                    <div class="texto_descriptivo_avisos">
                                        <h2>Aviso Legal</h2>
                                    </div>
                                </a>
                            </div>
                            <div class="mt-2" style="padding-left: 75px; margin-bottom: 20px;" id="info_aviso_privacidad">
                                <a routerLink="/">
                                    <img src="assets/img/avisoPrivacidad.png" alt="email" style="height: 70px; ">
                                    <div class="texto_descriptivo_avisos">
                                        <h2>Aviso de privacidad</h2>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-copyright pt-5">
            <p class="copyright-text">
                <span class="title">Carne Angus Certificada México - 2021</span>
                <span class="title">Todos los Derechos Reservados ®</span>
            </p>
            <a href="javascript:void(0)" class="back-to-top" (click)="gotoTop()"><i class="far fa-angle-up"></i></a>
        </div>
    </div>
</footer>